import React from "react";
import LegalPage from "./LegalPage";

export default function Disclaimer() {
  return (
    <LegalPage
      path="/disclaimer"
      heading="Disclaimer"
      updated="September 2026"
      title="Disclaimer | Registry Feed"
      description="Legal disclaimer covering Registry Feed's data products, third-party sources and business outcomes."
    >
      <p>The information available through Registry Feed is provided for general business purposes only. By using the Service you acknowledge and agree that:</p>
      <ul>
        <li>Registry Feed is <strong>not affiliated with the Ministry of Corporate Affairs (MCA), the Goods and Services Tax Network (GSTN), or any Indian government body</strong>. All references to MCA and GST are to publicly filed information — we are an independent B2B data platform.</li>
        <li>The datasets we deliver are compiled from public filings. We do our best to standardise and organise this information, but we do not guarantee accuracy, completeness, or that any particular field is populated for every record.</li>
        <li>Registry Feed does not guarantee sales outcomes, leads, meetings, or revenue. Any business result depends on your own outreach and product.</li>
        <li>The datasets should not be used as legal, tax, accounting or investment advice. Please consult qualified professionals for regulated advice.</li>
        <li>You are responsible for using the data in compliance with all applicable Indian laws, including data protection, telemarketing and anti-spam rules.</li>
      </ul>
      <p>If you disagree with any part of this disclaimer, please do not use the Service.</p>
    </LegalPage>
  );
}
